import { useEffect, useRef, useState } from 'react'
import { motion, useMotionValue, useTransform, animate } from 'framer-motion'
import { play } from '../lib/sounds.js'

/**
 * Animated count-up. Slot-machine feel.
 *
 * Props: value (number), duration (s), className, prefix, suffix, soundOnIncrease
 */
export default function PointsCounter({
  value = 0,
  duration = 0.8,
  className = '',
  prefix = '',
  suffix = '',
  soundOnIncrease = false,
}) {
  const motionValue = useMotionValue(value)
  const rounded = useTransform(motionValue, latest => Math.round(latest).toLocaleString())
  const [display, setDisplay] = useState(value.toLocaleString())
  const previousValue = useRef(value)

  useEffect(() => {
    const controls = animate(motionValue, value, {
      duration,
      ease: 'easeOut',
    })
    const unsubscribe = rounded.onChange(latest => setDisplay(latest))
    if (soundOnIncrease && value > previousValue.current) play('coin')
    previousValue.current = value
    return () => {
      controls.stop()
      unsubscribe()
    }
  }, [value, duration, motionValue, rounded, soundOnIncrease])

  return (
    <motion.span className={className} aria-live="polite">
      {prefix}{display}{suffix}
    </motion.span>
  )
}
